import { Box, Typography } from "@mui/material";
import { COLORS } from "../../../../styles/colors";

export interface PhotonMedication {
  name: string;
  photonMedicationId?: string;
  brandName?: string | null;
  genericName?: string | null;
  strength?: string | null;
  form?: string | null;
  description?: string | null;
}

export interface CustomMedication {
  name: string;
  isCustomOption: true;
}

export type MedicationOption = PhotonMedication | CustomMedication;

export interface SavedMedication {
  id: string;
  patientId: string;
  name: string;
  strength?: string;
  frequency?: string;
  startDate?: Date | null;
  endDate?: Date | null;
  photonPatientId?: string;
  photonMedicationId?: string;
	isCustomOption?: boolean;
  brandName?: string | null;
  genericName?: string | null;
  form?: string | null;
  description?: string | null;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

// Type guard functions
export const isCustomMedication = (medication: MedicationOption): medication is CustomMedication => {
  return 'isCustomOption' in medication && medication.isCustomOption === true;
};

export const isPhotonMedication = (medication: MedicationOption): medication is PhotonMedication => {
  return !('isCustomOption' in medication);
};

export const getOptionLabel = (option?: MedicationOption | null): string => {
	if (!option) return '';

	if (isPhotonMedication(option)) {
		return option.brandName || option.name;
	}

	return option.name;
};

export const renderOption = (props: React.HTMLAttributes<HTMLLIElement>, option: MedicationOption) => {
	console.log(option);
	if (isCustomMedication(option)) {
		return (
			<li {...props}>
				<Box>
					<Typography fontWeight={500}>
						Use custom: "{option.name}"
					</Typography>
					<Typography variant="body2" color={COLORS.GREY}>
						Add a medication not found in the database
					</Typography>
				</Box>
			</li>
		);
	}

	return (
		<li {...props}>
			<Box>
				<Typography fontWeight={500}>
					{option.brandName || option.name}
				</Typography>
				<Typography variant="body2" color={COLORS.GREY}>
					{option.genericName && `Generic: ${option.genericName}`}
					{option.strength && ` • ${option.strength}`}
					{option.form && ` • ${option.form}`}
				</Typography>
			</Box>
		</li>
	);
};